import ShModel from 'sh-www/models/sh-model';

import { attr } from '@ember-data/model';

export default class Nonce extends ShModel {
  @attr('string') uuid;
  @attr('date') createdAt;
  @attr('date') expiresAt;

  get isExpired() {
    return this.expiresAt < Date.now();
  }
}
